
export const logRelatedTypes = {
  AdminUser: 'Admin::User',

  ClientUser: 'Client::User',
  ClientEquipment: 'Client::Equipment',

  EstablishmentUser: 'Establishment::User',
};
